import { DOCUMENTS } from '../../constants/requerimentDocuments';
import { Channels } from '@/core/constants/channelConstants';
import { CREDIT_LIMIT_RANGES_DT } from '@/core/constants/promissoryNoteApplication';

export default {
  applies(context, taxRegimes) {
    return (
      context.isIncrease &&
      context.channel === Channels.RETAIL &&
      context.taxRegime === taxRegimes.COORPORATE.value
    );
  },
  fields(context) {
    const minRange = CREDIT_LIMIT_RANGES_DT[1]; // 50000 - 100000
    const middleRange = CREDIT_LIMIT_RANGES_DT[2]; // 100000 - 500000

    if (context.promissoryNoteAmount <= minRange.min) {
      return {
        [DOCUMENTS.PROMISSORY_NOTE.value]: DOCUMENTS.PROMISSORY_NOTE,
        [DOCUMENTS.SUBSCRIBER_ID.value]: DOCUMENTS.SUBSCRIBER_ID,
        [DOCUMENTS.SUBSCRIBER_ADDRESS.value]: DOCUMENTS.SUBSCRIBER_ADDRESS,
        [DOCUMENTS.TAX_STATUS_CERTIFICATE.value]:
          DOCUMENTS.TAX_STATUS_CERTIFICATE,
        [DOCUMENTS.ARTICLES_OF_INCORPORATION.value]:
          DOCUMENTS.ARTICLES_OF_INCORPORATION,
      };
    }
    if (
      context.promissoryNoteAmount > minRange.min &&
      context.promissoryNoteAmount <= minRange.max
    ) {
      return {
        [DOCUMENTS.PROMISSORY_NOTE.value]: DOCUMENTS.PROMISSORY_NOTE,
        [DOCUMENTS.SUBSCRIBER_ID.value]: DOCUMENTS.SUBSCRIBER_ID,
        [DOCUMENTS.GUARANTOR_ID.value]: DOCUMENTS.GUARANTOR_ID,
        [DOCUMENTS.SUBSCRIBER_ADDRESS.value]: DOCUMENTS.SUBSCRIBER_ADDRESS,
        [DOCUMENTS.GUARANTOR_ADDRESS.value]: DOCUMENTS.GUARANTOR_ADDRESS,
        [DOCUMENTS.TAX_STATUS_CERTIFICATE.value]:
          DOCUMENTS.TAX_STATUS_CERTIFICATE,
        [DOCUMENTS.ARTICLES_OF_INCORPORATION.value]:
          DOCUMENTS.ARTICLES_OF_INCORPORATION,
        [DOCUMENTS.CREDIT_BUREAU_AUTH.value]: DOCUMENTS.CREDIT_BUREAU_AUTH,
      };
    }
    if (
      context.promissoryNoteAmount > middleRange.min &&
      context.promissoryNoteAmount <= middleRange.max
    ) {
      return {
        [DOCUMENTS.PROMISSORY_NOTE.value]: DOCUMENTS.PROMISSORY_NOTE,
        [DOCUMENTS.SUBSCRIBER_ID.value]: DOCUMENTS.SUBSCRIBER_ID,
        [DOCUMENTS.GUARANTOR_ID.value]: DOCUMENTS.GUARANTOR_ID,
        [DOCUMENTS.SUBSCRIBER_ADDRESS.value]: DOCUMENTS.SUBSCRIBER_ADDRESS,
        [DOCUMENTS.GUARANTOR_ADDRESS.value]: DOCUMENTS.GUARANTOR_ADDRESS,
        [DOCUMENTS.TAX_STATUS_CERTIFICATE.value]:
          DOCUMENTS.TAX_STATUS_CERTIFICATE,
        [DOCUMENTS.ARTICLES_OF_INCORPORATION.value]:
          DOCUMENTS.ARTICLES_OF_INCORPORATION,
        [DOCUMENTS.CREDIT_BUREAU_AUTH.value]: DOCUMENTS.CREDIT_BUREAU_AUTH,
      };
    }
    // promissoryNoteAmount > 500000
    return {
      [DOCUMENTS.PROMISSORY_NOTE.value]: DOCUMENTS.PROMISSORY_NOTE,
      [DOCUMENTS.SUBSCRIBER_ID.value]: DOCUMENTS.SUBSCRIBER_ID,
      [DOCUMENTS.GUARANTOR_ID.value]: DOCUMENTS.GUARANTOR_ID,
      [DOCUMENTS.SUBSCRIBER_ADDRESS.value]: DOCUMENTS.SUBSCRIBER_ADDRESS,
      [DOCUMENTS.GUARANTOR_ADDRESS.value]: DOCUMENTS.GUARANTOR_ADDRESS,
      [DOCUMENTS.TAX_STATUS_CERTIFICATE.value]:
        DOCUMENTS.TAX_STATUS_CERTIFICATE,
      [DOCUMENTS.ARTICLES_OF_INCORPORATION.value]:
        DOCUMENTS.ARTICLES_OF_INCORPORATION,
      [DOCUMENTS.FINANCIAL_STATEMENT.value]: DOCUMENTS.FINANCIAL_STATEMENT,
      [DOCUMENTS.CREDIT_BUREAU_AUTH.value]: DOCUMENTS.CREDIT_BUREAU_AUTH,
    };
  },
};
